export default function Testimonials() {
  const testimonials = [
    {
      name: 'Sarah Johnson',
      role: 'Owner, Local Bakery',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20confident%20female%20small%20business%20owner%20in%20her%20thirties%20with%20warm%20smile%2C%20bakery%20owner%20headshot%20with%20friendly%20approachable%20expression%2C%20natural%20lighting%20soft%20focus%20background%2C%20diverse%20entrepreneur%20professional%20photography%2C%20high%20quality%208k&width=100&height=100&seq=testimonial-001&orientation=squarish',
      rating: 5,
      text: 'Outsmarwebs transformed our online presence! We went from no website to a beautiful, professional site that brings in new customers every week. The process was smooth and they explained everything in simple terms.'
    },
    {
      name: 'Michael Chen',
      role: 'Founder, Tech Startup',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20successful%20male%20entrepreneur%20in%20his%20forties%20with%20confident%20smile%2C%20tech%20startup%20founder%20headshot%20with%20modern%20professional%20look%2C%20clean%20background%20natural%20lighting%2C%20diverse%20business%20professional%20photography%2C%20high%20quality%208k&width=100&height=100&seq=testimonial-002&orientation=squarish',
      rating: 5,
      text: 'Best investment we made for our startup. The website looks amazing and works perfectly on all devices. Our conversion rate increased by 40% in the first month. Highly recommend their services!'
    },
    {
      name: 'Emily Rodriguez',
      role: 'Manager, Fitness Studio',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20energetic%20female%20fitness%20professional%20in%20her%20thirties%20with%20bright%20smile%2C%20gym%20manager%20headshot%20with%20confident%20friendly%20expression%2C%20natural%20lighting%20clean%20background%2C%20diverse%20business%20professional%20photography%2C%20high%20quality%208k&width=100&height=100&seq=testimonial-003&orientation=squarish',
      rating: 5,
      text: 'They created exactly what we needed - a simple, clean website that showcases our classes and makes it easy for clients to book. The support has been fantastic too. Worth every penny!'
    },
    {
      name: 'David Thompson',
      role: 'Owner, Home Services',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20reliable%20male%20service%20business%20owner%20in%20his%20fifties%20with%20trustworthy%20smile%2C%20home%20services%20contractor%20headshot%20with%20professional%20demeanor%2C%20natural%20lighting%20neutral%20background%2C%20diverse%20entrepreneur%20photography%2C%20high%20quality%208k&width=100&height=100&seq=testimonial-004&orientation=squarish',
      rating: 5,
      text: 'As a small business owner, I was worried about the cost and complexity of getting a website. Outsmarwebs made it affordable and easy. Now I get calls from the website daily!'
    },
    {
      name: 'Lisa Park',
      role: 'Director, Consulting Firm',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20sophisticated%20female%20business%20consultant%20in%20her%20forties%20with%20confident%20smile%2C%20consulting%20firm%20director%20headshot%20with%20executive%20presence%2C%20natural%20lighting%20professional%20background%2C%20diverse%20business%20leader%20photography%2C%20high%20quality%208k&width=100&height=100&seq=testimonial-005&orientation=squarish',
      rating: 5,
      text: 'Professional, responsive, and delivered on time. Our new website perfectly represents our brand and has helped us attract higher-quality clients. Couldn\'t be happier with the results.'
    },
    {
      name: 'James Wilson',
      role: 'Owner, Restaurant',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20passionate%20male%20restaurant%20owner%20in%20his%20forties%20with%20warm%20smile%2C%20chef%20and%20business%20owner%20headshot%20with%20friendly%20welcoming%20expression%2C%20natural%20lighting%20soft%20background%2C%20diverse%20entrepreneur%20photography%2C%20high%20quality%208k&width=100&height=100&seq=testimonial-006&orientation=squarish',
      rating: 5,
      text: 'Our online orders have tripled since launching the new website. The design is beautiful and it\'s so easy for customers to browse our menu and place orders. Great work!'
    }
  ];

  return (
    <section id="testimonials" className="py-16 sm:py-20 lg:py-24 bg-gradient-to-b from-white to-slate-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-1.5 sm:py-2 bg-yellow-100 text-yellow-700 rounded-full text-xs sm:text-sm font-semibold mb-3 sm:mb-4">
            <i className="ri-star-line"></i>
            Client Success Stories
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight px-4">
            What Our{' '}
            <span className="bg-gradient-to-r from-cyan-600 to-blue-600 bg-clip-text text-transparent">
              Clients Say
            </span>
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4">
            Don't just take our word for it - hear from businesses we've helped succeed online
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl sm:rounded-3xl p-6 sm:p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              {/* Rating */}
              <div className="flex gap-1 mb-4 sm:mb-6">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-base sm:text-lg"></i>
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-6 sm:mb-8">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 sm:gap-4">
                <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <div className="font-bold text-gray-900 text-sm sm:text-base">{testimonial.name}</div>
                  <div className="text-xs sm:text-sm text-gray-600">{testimonial.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 sm:mt-20 text-center">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8">
            <div>
              <div className="text-3xl sm:text-4xl lg:text-5xl font-bold bg-gradient-to-r from-cyan-600 to-blue-600 bg-clip-text text-transparent mb-2">
                200+
              </div>
              <div className="text-xs sm:text-sm text-gray-600">Happy Clients</div>
            </div>
            <div>
              <div className="text-3xl sm:text-4xl lg:text-5xl font-bold bg-gradient-to-r from-cyan-600 to-blue-600 bg-clip-text text-transparent mb-2">
                98%
              </div>
              <div className="text-xs sm:text-sm text-gray-600">Satisfaction Rate</div>
            </div>
            <div>
              <div className="text-3xl sm:text-4xl lg:text-5xl font-bold bg-gradient-to-r from-cyan-600 to-blue-600 bg-clip-text text-transparent mb-2">
                5 Days
              </div>
              <div className="text-xs sm:text-sm text-gray-600">Avg. Launch Time</div>
            </div>
            <div>
              <div className="text-3xl sm:text-4xl lg:text-5xl font-bold bg-gradient-to-r from-cyan-600 to-blue-600 bg-clip-text text-transparent mb-2">
                24/7
              </div>
              <div className="text-xs sm:text-sm text-gray-600">Support Available</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
